import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-lg-500px bg-white rounded p-10 p-lg-15 mx-auto"
}
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = {
  key: 0,
  href: "#",
  class: "mb-12"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-dark mb-3 mt-5" }
const _hoisted_6 = { class: "fv-row mb-10" }
const _hoisted_7 = { class: "d-flex flex-stack mb-2" }
const _hoisted_8 = { class: "form-label fw-bolder text-dark fs-6 mb-0" }
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "fv-row mb-10" }
const _hoisted_12 = { class: "form-label fs-6 fw-bolder text-dark" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "fv-row mb-10" }
const _hoisted_16 = { class: "form-label fs-6 fw-bolder text-dark" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = {
  type: "submit",
  value: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_24 = {
  key: 1,
  class: "position-relative",
  style: {"min-height":"100vh !important"}
}
const _hoisted_25 = {
  class: "position-absolute",
  style: {"top":"50%","left":"50%","transform":"translate(-50%, -50%)","width":"80%"}
}
const _hoisted_26 = { class: "overflow-x-auto w-100" }
const _hoisted_27 = {
  class: "text-center mb-8 fw-bolder",
  style: {"color":"#4e046b"}
}
const _hoisted_28 = { class: "table table-striped text-center rounded-0 overflow-hidden" }
const _hoisted_29 = {
  class: "text-white py-3",
  style: {"background-color":"#4e046b"}
}
const _hoisted_30 = { class: "p-5" }
const _hoisted_31 = { class: "p-5" }
const _hoisted_32 = { class: "p-5" }
const _hoisted_33 = { class: "p-5" }
const _hoisted_34 = { class: "p-5" }
const _hoisted_35 = { class: "p-5" }
const _hoisted_36 = {
  class: "btn btn-sm text-white fw-bold",
  style: {"background-color":"#4e046b"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.items.length <= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Form, {
            class: "form w-100",
            id: "kt_login_signin_form",
            onSubmit: _ctx.fetchData,
            "validation-schema": _ctx.login
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.appGlobalConfig)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_3, [
                      _createElementVNode("img", {
                        alt: "Logo",
                        src: _ctx.appGlobalConfig.image.url,
                        style: {"width":"250px","height":"250px","border-radius":"50%"}
                      }, null, 8, _hoisted_4)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("auth.show_pending_invoices")), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate("view.civil_id")), 1)
                ]),
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: "number",
                  name: "civil_id",
                  modelValue: _ctx.row.civil_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.row.civil_id) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ErrorMessage, { name: "civil_id" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.translate("view.mobile")), 1),
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: "number",
                  modelValue: _ctx.row.mobile,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.row.mobile) = $event)),
                  name: "mobile"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_ErrorMessage, { name: "mobile" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate("view.country_code")), 1),
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  modelValue: _ctx.row.country_code,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.row.country_code) = $event)),
                  name: "country_code"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_ErrorMessage, { name: "country_code" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", _hoisted_20, [
                  (!_ctx.signInLoader)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.translate("auth.show")), 1))
                    : _createCommentVNode("", true),
                  (_ctx.signInLoader)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                        _createTextVNode(_toDisplayString(_ctx.translate("auth.please_wait")) + "... ", 1),
                        _hoisted_23
                      ]))
                    : _createCommentVNode("", true)
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.items.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("h1", _hoisted_27, _toDisplayString(_ctx.$t("auth.pending_invoices")), 1),
              _createElementVNode("table", _hoisted_28, [
                _createElementVNode("thead", _hoisted_29, [
                  _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.$t("auth.invoiceId")), 1),
                  _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.$t("auth.clientName")), 1),
                  _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t("auth.companyName")), 1),
                  _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t("auth.amount")), 1),
                  _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t("auth.date")), 1),
                  _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t("auth.actions")), 1)
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.invoice_key), 1),
                      _createElementVNode("td", null, _toDisplayString(item.user.name), 1),
                      _createElementVNode("td", null, _toDisplayString(item.company.name), 1),
                      _createElementVNode("td", null, _toDisplayString(item.price), 1),
                      _createElementVNode("td", null, _toDisplayString(item.invoice_date), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: {
                    name: 'show-pending-invoices',
                    params: { id: item.encrypt_id },
                  },
                          class: "menu-link px-5"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", _hoisted_36, _toDisplayString(_ctx.$t("auth.invoicePaid")), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}